export default __webpack_public_path__ + "static/media/logo.b17a6e6b.svg";